import { render, staticRenderFns } from "./From.vue?vue&type=template&id=ed90ffae&scoped=true&"
import script from "./From.vue?vue&type=script&lang=js&"
export * from "./From.vue?vue&type=script&lang=js&"
import style0 from "./From.vue?vue&type=style&index=0&id=ed90ffae&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed90ffae",
  null
  
)

export default component.exports